<template>
  <div>
    <b-card-header class="pb-50">
      <h5>
        Filtres
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Competition</label>
          <v-select
            :dir="'ltr'"
            :value="competitionFilter"
            :options="competitionOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:competitionFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Supprimées</label>
          <v-select
            :dir="'ltr'"
            :value="trashedFilter"
            :options="trashedOptions"
            :clearable="false"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:trashedFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </div>
</template>

<script>
import {
  BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'PlatformListsFilter',
  components: {
    BRow,
    BCol,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    competitionFilter: {
      type: [String, null],
      default: null,
    },
    trashedFilter: {
      type: [Boolean, null],
      default: null,
    },
    competitionOptions: {
      type: Array,
      required: true,
    },
    trashedOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
